import React, { useState } from 'react';
import { toast } from 'react-toastify';

// Styles
import { Button, CircularProgress, Grid, Modal, Typography } from '@mui/material';
import { X } from 'phosphor-react';

// Apis
import { cancelCommunicationMessage } from 'js/library/utils/API/cancelCommunicationMessage';

const buttonCloseStyle = {
  position: 'absolute',
  top: '1rem',
  right: '1rem',
  minWidth: 'auto',
  padding: '0.5rem',
  borderRadius: '50%',
  color: '#000',
};

const containerStyle = {
  padding: '2rem',
  backgroundColor: 'white',
  borderRadius: '8px',
  maxWidth: {
    xs: '90%', // Mobile
    md: '45%', // Desktop
  },
  width: '100%',
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
};

export const ModalCancelMessage = ({ budgetResume, open, close, reload }) => {
  const { communicationMessageId } = budgetResume || {};
  const [loading, setLoading] = useState(false);

  const cancelBudget = async () => {
    setLoading(true);
    try {
      await cancelCommunicationMessage(communicationMessageId);

      toast.success('Orçamento cancelado com sucesso!');
      reload((prev) => !prev);
      close();
    } catch (error) {
      toast.error(error);
      console.error('Error canceling budget =>', error);
    } finally {
      setLoading(false);
    }
  };

  if (!open) return null;

  return (
    <Modal open={open} onClose={close}>
      <Grid container sx={containerStyle}>
        <Button onClick={close} sx={buttonCloseStyle}>
          <X size={25} />
        </Button>

        <Grid item md={12} xs={12}>
          <Typography variant="h5" sx={{ fontWeight: 700 }}>
            Cancelar orçamento
          </Typography>
        </Grid>

        <Grid item md={12} xs={12} sx={{ textAlign: 'center', mt: 4 }}>
          <Typography variant="h5">Tem certeza que deseja cancelar este orçamento?</Typography>
        </Grid>

        <Grid
          item
          md={12}
          xs={12}
          sx={{ display: 'flex', justifyContent: 'center', marginTop: '2rem', gap: 2 }}
        >
          <Button
            disabled={loading}
            onClick={cancelBudget}
            variant="contained"
            sx={{ minWidth: '8rem' }}
          >
            {loading ? (
              <CircularProgress size={23} thickness={6} sx={{ color: '#fff' }} />
            ) : (
              'Cancelar'
            )}
          </Button>

          <Button onClick={close} variant="outlined" sx={{ minWidth: '8rem' }}>
            Voltar
          </Button>
        </Grid>
      </Grid>
    </Modal>
  );
};
